import React, { useState, useContext, useEffect, useCallback } from 'react'
import DashboardMain_Orion from '../DashboardMain_Orion/DashboardMain_Orion'
import * as $ from 'jquery'
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_orion'
import useHttp from '../../../hook/use-http'
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_orion'
import AppContext from '../../../store/AppContext'

// import TwoChartTemplate_Orion_Orion from "./TwoChartTemplate_Orion_Orion";
import SingleBoxRange_Orion from './SingleBoxRange_Orion'
import SingleSoc_Orion from './SingleSoc_Orion'
import Topkpis_Orion from './Topkpis_Orion'
import TopFiveSection_Orion from './TopFiveSection_Orion'
import Drive_Filter_Orion from './Drive_Filter_Orion'
import PageSecond_Orion from './PageSecond_Orion'
import AvgDischargeDuration_Orion from './AvgDischargeDuration_Orion'
import SocDischargeCycle_Orion from './SocDischargeCycle_Orion'
import NetEnergyConsumption_Orion from './NetEnergyConsumption_Orion'
import EnergyBoxRange_Orion from "./EnergyBoxRange_Orion"
import NetEnergyConsumptionkwh_Orion from './NetEnergyConsumptionkwh_Orion'
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"
import { decodeToken } from 'react-jwt';
import "./Driveanalysis_Custom_Orion.css"

export default function Driveanalysis_Orion() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const [chartType, setChartSelected] = useState('netenergy')
  const [chartTypeBox, setChartBoxSelected] = useState('netenergybox')
  const log_data = (data) => {
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "driveanalysis_orion" } }, log_data)
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
    });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const changeNet = (selectedOption) => {
    setChartSelected(selectedOption)
  }
  const changeNetBox = (selectedOption) => {
    setChartBoxSelected(selectedOption)
  }
  const loggedInUser = useSelector(selectLoggedInUser);

  if (gloablfilter.pageSelected === 1) {
    return (
      <DashboardMain_Orion>
        <Drive_Filter_Orion onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
        <div className="container-fluid busdrpg1">
          <Topkpis_Orion gloablfilter={gloablfilter} />
          <section className="graphs busdrpg1">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-lg-3 mb-3">
                <div id="wrapper" className="toggled">
                  <div id="page-content-wrapper">
                    <TopFiveSection_Orion singleVinSelected={singleVinSelected} gloablfilter={gloablfilter}></TopFiveSection_Orion>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12 col-lg-9">

                <div className="row mb-3" style={{}}>
                  {/* <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-12' : 'col-lg-6 col-md-4 col-sm-12')}> */}
                  <div className='col-lg-4 col-md-4 col-sm-12'>
                    <SingleBoxRange_Orion title="Real World Range Boxplot" gloablfilter={gloablfilter} apiend="rangebarchart"></SingleBoxRange_Orion>
                  </div>
                  {/* <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-12' : 'col-lg-6 col-md-4 col-sm-12')}> */}
                  <div className='col-lg-4 col-md-4 col-sm-12'>
                    <SingleSoc_Orion title="Real World Range Distribution" gloablfilter={gloablfilter} apiend="rangebarchart"></SingleSoc_Orion>
                  </div>
                  {/* { */}
                  {/* loggedInUser.flagForHideShow === "ERC" && */}
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <AvgDischargeDuration_Orion title="Average discharge duration" gloablfilter={gloablfilter} apiend="avgdischargeduration"></AvgDischargeDuration_Orion>
                  </div>
                  {/* } */}
                </div>
                <div className="row mb-3" style={{}}>

                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="v-title chartbox chartbox_bus">
                      <div className="titlebg_orion text-fit">Net Energy Consumption</div>
                      <div className="col-lg-6 col-md-6 col-sm-12 mt-1">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeNet(event.target.value)}
                          value={chartType}>
                          <option value="netenergy">kWh/km</option>
                          <option value="netkwh">kWh</option>
                        </select>
                      </div>
                      {
                        (chartType === "netenergy") ?
                          <NetEnergyConsumption_Orion gloablfilter={gloablfilter} apiend="netenergyconsumption" type={chartType}></NetEnergyConsumption_Orion>
                          : <NetEnergyConsumptionkwh_Orion title="Net Energy" gloablfilter={gloablfilter} apiend="netenergykwh" type={chartType}></NetEnergyConsumptionkwh_Orion>

                      }
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="v-title chartbox chartbox_bus">
                      <div className="titlebg_orion text-fit p-2">Net Energy Boxplot</div>
                      <div className="col-lg-6 col-md-6 col-sm-12 mt-1">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeNetBox(event.target.value)}
                          value={chartTypeBox}>
                          <option value="netenergybox">kWh/km</option>
                          <option value="netkwhbox">kWh</option>
                        </select>
                      </div>
                      {
                        (chartTypeBox === "netenergybox") ?
                          <EnergyBoxRange_Orion title="Net Energy" gloablfilter={gloablfilter} apiend="netenergyconsumption"></EnergyBoxRange_Orion>
                          : <EnergyBoxRange_Orion title="Net Energy" gloablfilter={gloablfilter} apiend="netenergykwh"></EnergyBoxRange_Orion>
                      }
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <SocDischargeCycle_Orion title="SoC Discharge/Cycle Analysis" gloablfilter={gloablfilter} apiend="socdichargecycle"></SocDischargeCycle_Orion>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </DashboardMain_Orion>
    )
  } else {
    return (
      <DashboardMain_Orion>
        <PageSecond_Orion gloablfilter={gloablfilter} pageChange={pageChange} />
      </DashboardMain_Orion>
    );
  }
}
